import CandidateNotesPageContent from './CandidateNotesPageContent.container';

export default CandidateNotesPageContent;
